import { createContext, useEffect, useState, useRef } from "react";
import * as signalR from '@microsoft/signalr';

export const AddressContext = createContext();

export const AddressProvider = ({ children }) => {
    //Manual Addresses Register ->
    const [streets, setStreets] = useState([]);
    const [addressInfo, setAddressInfo] = useState([]);
    const [residences, setResidences] = useState([]);
    const [permanentStreetForManualEdit, setPermanentStreetForManualEdit] = useState({ id: '', name: '', residenceId: '' });
    const [currentStreetForManualEdit, setCurrentStreetForManualEdit] = useState({ id: '', name: '', residenceId: '' });
    const [currentAddressForManualEdit, setCurrentAddressForManualEdit] = useState({ id: '', streetId: '', addressNumber: '' });
    const [permanentAddressForManualEdit, setPermanentAddressForManualEdit] = useState({ id: '', streetId: '', addressNumber: '' });
    //<- Manual Addresses Register

    const [advSchools, setAdvSchools] = useState({});
    const [parentEgnExist, setParentEgnExist] = useState();
    const [parentData, setParentData] = useState({
        egn: '',
        email: '',
        name: '',
        phone: '',
    });
    const [addressResidence, setAddressResidence] = useState([]);

    const [siblingIsValid, setSiblingIsValid] = useState({
        '10': false,
        '10Error': '',
        '20': false,
        '20Error': ''
    });
    const [siblingLnchs, setSiblingLnchs] = useState({
        '10': false,
        '10Error': '',
        '20': false,
        '20Error': ''
    });
    const [dontHaveCompletedGroup, setdontHaveCompletedGroup] = useState({ 0: '' });
    const [twinsResidence, setTwinsResidence] = useState({});
    const connectionRef = useRef(null);

    useEffect(() => {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(process.env.REACT_APP_BACKEND_URL == 'api/' ? "/registerHub" : 'https://localhost:7127/registerHub')
            .withAutomaticReconnect()
            .build();

        connection.start()
            .then(() => {
                console.log('Connection established.');
                connectionRef.current = connection;
            })
            .catch(error => {
                console.error('Error establishing connection:', error);
            });

        connection.onreconnecting((error) => {
            console.warn("🔄 Reconnecting...", error);
        });

        connection.onreconnected((connectionId) => {
            console.log("✅ Reconnected!");
        });

        connection.on("ReceivePopulatedPlaces", (residences) => {
            setResidences(residences);
        });

        connection.on("ReceiveCurrentStreetById", (street) => {
            setCurrentStreetForManualEdit(street);
        });

        connection.on("ReceivePermanentStreetById", (street) => {
            setPermanentStreetForManualEdit(street);
        });

        connection.on("ReceiveCurrentStreetByCode", (street) => {
            setCurrentStreetForManualEdit(street);
        });

        connection.on("ReceivePermanentStreetByCode", (street) => {
            setPermanentStreetForManualEdit(street);
        });

        connection.on("ReceiveStreets", (address) => {
            //console.log('Streets: ', address);
            setStreets(address);
        });

        connection.on("ReceiveAddressInfo", (address) => {
            //console.log('AdresInfo: ', address);
            setAddressInfo(address);
        });

        connection.on("ReceiveCurrentAddressInfo", (address) => {
            setCurrentAddressForManualEdit(address);
        });

        connection.on("ReceivePermanentAddressInfo", (address) => {
            setPermanentAddressForManualEdit(address);
        });

        connection.on("ReceiveAdvantageSchools", (schools) => {
            //console.log('Schools: ', schools);
            setAdvSchools(schools);
        });

        connection.on("ValidateNameEgnInAddressResidence", (addressResidanceData) => { // here receive param from backend
            //console.log('Address residence: ', addressResidanceData);
            setAddressResidence(addressResidanceData); // here set in state frontend
        });

        connection.on("ValidateEgnInAddressResidence", (addressResidanceData) => { // here receive param from backend
            //console.log('Address residence: ', addressResidanceData);
            setAddressResidence(addressResidanceData); // here set in state frontend
        });

        connection.on("ValidateNameEgnInChildrenSchool", (siblingIsValid, advCode, index) => {
            //console.log('Sibling is valid: ', siblingIsValid);
            if (typeof siblingIsValid == 'boolean') {
                setSiblingIsValid(state => ({
                    ...state,
                    [advCode]: siblingIsValid,
                    [`${index}${advCode}Error`]: '',
                }));
            } else {
                setSiblingIsValid(state => ({
                    ...state,
                    [advCode]: false,
                    [`${index}${advCode}Error`]: siblingIsValid,
                }));
            }

        });

        connection.on("IsCompletePreparatoryGroup", (isComplete, index) => {
            setdontHaveCompletedGroup(state => ({ ...state, [index]: isComplete }));
        })

        connection.on("ValidateTwinAddressResidence", (addressResidanceData, index) => {
            //console.log('twREs:', addressResidanceData)
            setTwinsResidence(state => ({
                ...state,
                [index]: addressResidanceData,
            }));
        });

        connection.on("ParentEgnExist", (isExist) => {
            setParentEgnExist(state => isExist);
        });

        connection.on("GetParentData", (parentData) => {
            setParentData(parentData);
        });

        return () => {
            if (connectionRef.current) {
                connectionRef.current.stop()
                    .then(() => {
                        console.log('Connection closed.');
                    })
                    .catch(error => {
                        console.error('Error while closing SignalR connection:', error);
                    });
            }
        };
    }, [])

    const getResidences = () => {
        if (connectionRef.current) {
            connectionRef.current.invoke("GetPopulatedPlaces")
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    };

    const searchAddressInputChange = (address) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("SearchStreet", address)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    };

    const getAddressById = (addressId, residenceId, isCurrentStreet) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("SearchAddressById", Number(addressId), residenceId, isCurrentStreet)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    };

    const getStreetByCode = (addressId, isCurrentStreet) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("GetStreetByCode", addressId, isCurrentStreet)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    };

    const getStreetById = (addressId, isCurrentStreet) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("GetStreetById", addressId, isCurrentStreet)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    };

    const searchAddressInforamtion = (streetId, residenceId) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("SearchAddress", streetId, residenceId)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    }

    const searchAdvantageSchools = (permanentAddressId, currentAddressId) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("SearchAdvantageSchools", permanentAddressId, currentAddressId)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    }

    const validateAddressResidence = (egn, name) => {
        if (connectionRef.current) {
            //console.log('vtr')
            connectionRef.current.invoke("ValidateChildNameAndEGN", egn, name, null)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    }

    const validateAddressResidenceByEgn = (egn) => {

        if (connectionRef.current) {
            //console.log('vtr')
            connectionRef.current.invoke("ValidateChildEGN", egn, null)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    }

    const validateSiblingLnch = (birthDate, name, advCode, schoolId, index) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("ValidateSiblingNameAndLnch", birthDate, name, advCode, schoolId, index)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    }

    const validateSibling = (egn, name, advCode, schoolId, index) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("ValidateSiblingNameAndEGN", egn, name, advCode, schoolId, index)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    }

    const checkParentEgnIfExist = (egn) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("IsParentEGNExist", egn)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    }

    const getParentDataIfExist = (egn) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("GetParentData", egn)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    }

    const isChildHavePreparatoryGroup = (egn, name, schoolId, index) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("IsChildHavePreparatoryGroup", egn, name, schoolId, index)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    }

    const cleanChildHavePreparatoryGroupState = (index) => {
        setdontHaveCompletedGroup(state => ({ ...state, [index]: '' }));
    }

    const twinsResidenceValidation = (egn, name, index) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("ValidateChildNameAndEGN", egn, name, index)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    }


    const cleanSiblingErrors = (i, advCode) => {
        setSiblingIsValid(state => ({
            ...state,
            [advCode]: false,
            [`${i}${advCode}Error`]: ''
        }))
    }



    return (
        <AddressContext.Provider value={{
            streets,
            searchAddressInputChange,
            addressInfo,
            searchAddressInforamtion,
            advSchools,
            searchAdvantageSchools,
            addressResidence,
            validateAddressResidence,
            siblingIsValid,
            validateSibling,
            getStreetByCode,
            isChildHavePreparatoryGroup,
            dontHaveCompletedGroup,
            cleanChildHavePreparatoryGroupState,
            twinsResidenceValidation,
            twinsResidence,
            cleanSiblingErrors,
            validateSiblingLnch,
            siblingLnchs,
            checkParentEgnIfExist,
            parentEgnExist,
            getParentDataIfExist,
            parentData,
            getResidences,
            residences,
            permanentStreetForManualEdit,
            currentStreetForManualEdit,
            getStreetById,
            getAddressById,
            currentAddressForManualEdit,
            permanentAddressForManualEdit,
            validateAddressResidenceByEgn
        }}>
            {children}
        </AddressContext.Provider>
    )
}